export default "__VITE_ASSET__AheUoK3u__"